import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { of } from 'rxjs';
import { CmsApiResponse, CmsPageService } from '../services/cms-page.service';

export const cmsPageResolver: ResolveFn<CmsApiResponse | null> = (route) => {
  const identifier = route.data['cmsIdentifier'] as string | undefined;
  if (!identifier) {
    return of(null);
  }

  return inject(CmsPageService).fetchByIdentifier(identifier);
};
